



















import Debug from 'debug'
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { TranslateResult } from 'vue-i18n';
import { resolve } from '@/app/container';
import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';
import {
  SectionInteractionEvent,
  SectionInteractedEventName
} from '@/app/statistics/events/section-interaction-events';
import { ADMONITION_TYPE } from '@/app/statistics/handlers/admonitions-completion-handler';
import {
  IncludeComponentsService,
  IncludeComponentsServiceSymbol
} from '@/app/presenter/includer/include-components-service';
import { ChildComponents } from "@/app/shared/utils/child-components";
import * as Api from "@/app/interaction/api";
import { AdmonitionContent, AdmonitionState } from "./admonition-interfaces";

const debug = Debug('admonition-component')

@Component
export default class AdmonitionComponent extends Vue
  implements Api.InteractiveComponent<AdmonitionState, AdmonitionContent> {

  @Prop({
    required: true
  })
  public meta: Api.InteractionComponentMeta;

  @Prop({
    required: true
  })
  public content: AdmonitionContent;

  @Prop({
    required: true
  })
  public state: AdmonitionState | null;

  private open: boolean = false;

  private touched: boolean = false;

  private includeComponentsService: IncludeComponentsService
    = resolve<IncludeComponentsService>(IncludeComponentsServiceSymbol);

  private childComponents: ChildComponents = new ChildComponents('admonition-component')

  private mounted() {
    this.open = this.state?.open || false;
    this.touched = this.state?.touched || false;
  }

  private get cssClassesInternal(): string {
    let classes: string = this.content.cssClasses;

    if (this.open) {
      classes = `${classes} open`;
    }

    return classes;
  }

  private async onClick() {
    if (!this.content.isReveal) {
      return;
    }

    this.open = !this.open;
    this.childComponents.destroy()
    if (this.open) {
      const $container = $(`#${this.meta.id} .admonition__content`);
      // TODO: cancel
      const components = await this.includeComponentsService.includeComponents($container, { cancel: false });
      this.childComponents.register(components)
    }

    let progressChanged = false
    if (!this.touched) {
      this.touched = true;
      progressChanged = true
    }

    this.emitInteractionStateChanged();

    if (progressChanged) {
      this.emitInteractionResultChanged();
    }
  }

  private beforeDestroy(): void {
    this.childComponents.destroy()
  }

  @Emit('interaction-result-changed')
  public emitInteractionResultChanged() {
    const progress = this.content.isReveal && this.touched || !this.content.isReveal ? 1 : 0;

    const result: Api.Result = {
      progress,
      status: progress < 1 ? 'incomplete' : 'completed'
    }

    debug('emitInteractionResultChanged', result);

    return result
  }

  @Emit('interaction-state-changed')
  public emitInteractionStateChanged() {
    const state = {
      open: this.open,
      touched: this.touched,
    };

    debug('emitInteractionStateChanged', state);

    return state
  }
}
